import { createFileRoute } from '@tanstack/react-router'
import NotFound from '@/components/notfound'

export const Route = createFileRoute('/404')({
  component: NotFoundRoute,
})

function NotFoundRoute() {
  return <NotFound />
}
